import { formatDate } from "./formatDate";

// Shared by vehicle, route and stop lists.
export const formatLastUpdate = (value, translate) => {
  if (value === undefined || value === null || value === "") return "--";

  const date = typeof value === "number"
    ? new Date(value < 1e12 ? value * 1000 : value)
    : new Date(value);
  if (Number.isNaN(date.getTime())) return "--";

  const diffMs = Date.now() - date.getTime();
  if (diffMs < 60000) return translate ? translate("Just now") : "Just now";
  if (diffMs < 3600000) {
    const count = Math.floor(diffMs / 60000);
    return translate
      ? translate("{{count}} min ago", { count })
      : `${count} min ago`;
  }
  return formatDate(date) || "--";
};
